import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "container p-0 mt-2" }
const _hoisted_2 = { class: "form-check" }
const _hoisted_3 = ["id", "required"]
const _hoisted_4 = ["for", "innerHTML"]
const _hoisted_5 = { class: "invalid-feedback" }
const _hoisted_6 = {
  key: 0,
  class: "form-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["form-group", { 'was-validated': $props.wasValidated }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          id: 'legalCheckbox-' + $props.element.name,
          class: "form-check-input",
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.checked) = $event)),
          required: $options.isRequired,
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.onChange && $options.onChange(...args)))
        }, null, 40, _hoisted_3), [
          [_vModelCheckbox, $data.checked]
        ]),
        _createElementVNode("label", {
          class: "form-check-label",
          for: 'legalCheckbox-' + $props.element.name,
          innerHTML: $options.getTextFor($props.element.text, $props.lang)
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, _toDisplayString($options.getTextFor($props.element.invalid, $props.lang)), 1)
      ]),
      ($props.element.explanation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($options.getTextFor($props.element.explanation, $props.lang)), 1))
        : _createCommentVNode("", true)
    ], 2)
  ], 512)), [
    [_vShow, !$props.hidden]
  ])
}